// Module
var code = `<div class="alert alert--danger" ng-if="!\$ctrl.areEntriesValid">
  <ul>
    <li ng-repeat="msg in \$ctrl.errorMessages"><strong>{{msg}}</strong></li>
  </ul>
</div>
<ng-form name="\$ctrl.form">
  <table class="table">
    <thead>
    <tr>
      <th colspan="2">Min amount</th>
      <th colspan="2">Max amount</th>
      <th colspan="1"></th>
      <th colspan="2"></th>
    </tr>
    </thead>
    <tbody>
    <tr ng-repeat="c in \$ctrl.config">
      <validator condition="\$ctrl.areEntriesValid" ></validator>
      <td colspan="2">
        <cash ng-model="c.minAmount" min="0.01"
              ng-change="\$ctrl.validateEntries()"
              required="true"></cash>
      </td>
      <td colspan="2">
        <cash ng-model="c.maxAmount" min="0.01"
              ng-change="\$ctrl.validateEntries()"
        ></cash>
      </td>
      <td colspan="1">
        <div class="alert" ng-if="!c.id">
          <strong>New entry</strong>
        </div>
      </td>
      <td colspan="2">
        <button type="button" class="btn btn-danger" ng-click="\$ctrl.remove(\$index)">
          Remove
        </button>
      </td>
    </tr>
    <tr>
      <td>
        <button ng-click="\$ctrl.sortByMinAmount()" type="button" class="btn btn-info">
          Sort by min amount
        </button>
      </td>
      <td>
        <button ng-click="\$ctrl.add()" type="button" class="btn btn-primary">
          Add
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</ng-form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/non-commensurate/customer-type-config.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;